import CmallQuery from "@tencent/midas-cgi/cgis/cmall_query"
import { getCgiObj } from "./cgi"
import { sessionObj } from "@tencent/midas-util"

interface optionType {
  pf: string
  sandbox: string | number
  sessionObj: sessionObj
  offerId: string
  channel_id?: string
}

interface BindOptions {
  third_openid: string
  third_openkey: string
  third_session_id: string
  third_session_type: string
  refresh_token?: string
}

const defaultConfig = {
  hideLoading: false
}

class CmallQueryApi {
  private cgiObj
  private cgiNames
  private channel_id: string | undefined
  /**
   * 构造函数
   * @param options 初始化cgiObj所需参数
   */
  constructor(options: optionType) {
    const { pf, sandbox, sessionObj, offerId, channel_id } = options
    this.channel_id = channel_id
    this.cgiObj = getCgiObj({
      pf,
      sandbox,
      sessionObj,
      offerId
    })

    this.cgiNames = {
      CmallQuery: new CmallQuery(defaultConfig)
    }
  }

  /**
   * 查询绑定账号，主登录态为第三方登录态
   * @param
   * 会先查txcz存的登录态，没有就去查业务存的
   * 如果业务返回的微信，要认为没有绑定
   */
  queryBindAccount(): Promise<any> {
    const params = {
      cmd: 33,
      action: "get",
      channel_id: this.channel_id
    }

    return this.cgiObj.request(this.cgiNames["CmallQuery"], params)
  }

  /**
   * 设置绑定账号，主登录态为QQ/WX
   * @param
   */
  setBindAccount({ third_openid, third_openkey, third_session_id, third_session_type, refresh_token }: BindOptions): Promise<any> {
    const params = {
      cmd: 33,
      // cmd: "third_party_login_bind_acct_info",
      action: "bind",
      third_openid,
      third_openkey,
      third_session_id,
      third_session_type,
      channel_id: this.channel_id,
      refresh_token
    }

    return this.cgiObj.request(this.cgiNames["CmallQuery"], params)
  }

  /**
   * 清空txcz侧的绑定账号，主登录态为第三方登录态
   * @param
   */
  clearBindAccount(): Promise<any> {
    const params = {
      cmd: 33,
      action: "cancel",
      channel_id: this.channel_id
    }

    return this.cgiObj.request(this.cgiNames["CmallQuery"], params)
  }
}

export { CmallQueryApi }
